export default __webpack_public_path__ + "static/media/DF-2.53fb5865.png";